module.exports = __webpack_public_path__ + "img/lvg.f3016219.png";